import { Link } from "react-router-dom";
import { ROUTES } from "@/routes/paths";

export function MobileTopBar() {
  return (
    <header className="sticky top-0 z-20 flex h-14 items-center justify-between border-b border-border bg-card px-4 md:hidden">
      <Link to={ROUTES.HOME} className="text-base font-semibold text-foreground">
        CrossBorder
      </Link>
    </header>
  );
}

export default MobileTopBar;
